export default "__VITE_ASSET__29d8cf5b__"